import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function PaymentCancelPage() {
  const { t } = useTranslation();
  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#0d1b2a", padding: "1rem" }} data-testid="payment-cancel-page">
      <div className="gold-card" style={{ maxWidth: 420, width: "100%", padding: "2rem", textAlign: "center", background: "#fdfaf3" }}>
        <XCircle size={48} style={{ margin: "0 auto 1rem", color: "#9a7530" }} />
        <h1 style={{ fontFamily: "Cinzel, serif", fontSize: "1.2rem", color: "#0d1b2a" }}>
          {t("payments.cancelTitle", "Plată anulată")}
        </h1>
        <p className="kv-label" style={{ marginTop: 8 }}>
          {t("payments.cancelBody", "Nu s-a efectuat nicio plată. Poți relua oricând din aplicație.")}
        </p>
        <Link to="/" className="btn-outline-gold" style={{ display: "inline-block", marginTop: "1.25rem" }}>
          {t("payments.backHome", "Înapoi la aplicație")}
        </Link>
      </div>
    </div>
  );
}
